import React, { useEffect, useState, useRef } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import "react-router-dom";
import { get_workflow_data } from "../../components/Workflow_Components/Api";
import {
  setWorkflowName,
  setWorkflowDescription,
  setWorkflowRerunFlag,
} from "ReduxStore/Slices/workflowSlice";
import CreateAutmationBottamSection from "./CreateAutomationSection/CreateAutmationBottamSection";
import SelectAutomation from "views/Engagement_Builder/CreateAutomationSection/SelectAutomation";
import AutomationInfo from "./CreateAutomationSection/AutomationInfo";
import { useDispatch, useSelector } from "react-redux";
import SupportLink from "../Common/SupportLink";

const CreateAutomation = (props) => {
  const dispatch = useDispatch();
  const workflowData = useSelector((state) => state.workflowSetter);
  useEffect(() => {
    if (workflowData.backFromAllWorkflows) {
      get_workflow_data(workflowData.workflowId)
        .then((data) => {
          dispatch(setWorkflowName(data.name));
          dispatch(setWorkflowDescription(data.description));
          dispatch(setWorkflowRerunFlag(data.rerunOnTrigger));
        })
        .catch((e) => { });
    }
  }, []);

  return (
    <div>
      <SupportLink link='https://kapitalwise.com/user-guide/engagement-builder/' />

      <div className="page_heading">
        <h2>Create Automation</h2>
      </div>
      <form>
        <div className="audieneOuter">
          <AutomationInfo></AutomationInfo>
          {workflowData.backFromAllWorkflows ? (
            <CreateAutmationBottamSection></CreateAutmationBottamSection>
          ) : (
            <SelectAutomation></SelectAutomation>
          )}
        </div>
      </form>
    </div>
  );
};

export default CreateAutomation;
